export class JobTitleOption {
  constructor(data) {
    this.id = data.id;
    this.label = data.name;
  }
}
